import React, { useEffect, useContext, useState } from 'react';
import Icon_Close from '../../../Assets/Icons/Icon_Close.png';
import Icon_Success from '../../../Assets/Icons/Icon_Color_Success.png';
import { Context_UI } from '../../../Contexts/Context_UI';
import { useScheduleManagement } from '../../../Contexts/Context_ScheduleManagement';
import { useMapRenderer } from '../../../Contexts/Context_MapRenderer';
import UI_Card from '../../ERUMAUI/UI_Card';
import UI_ChipGroup from '../../ERUMAUI/UI_ChipGroup';
import { useAccounts } from '../../../Contexts/Context_Accounts';
import UI_Divider from '../../ERUMAUI/UI_Divider';
import UI_Toggle from '../../ERUMAUI/UI_Toggle';
import { useTemplating } from '../../../Contexts/Context_Templating';
import { useStatus } from '../../../Contexts/Context_Status_Global';
import UI_Button from '../../ERUMAUI/UI_Button';
import UI_UpdatingStatus from '../../ERUMAUI/UI_UpdatingStatus';

export default function Subwindow_Modal_Reservation_Approve_Delegate({ id, zIndex, isActive }) {
    const UI = useContext(Context_UI);
    const { Schedule_Information, Time_Range_Parse, Schedule_Action_Mode, Status_Parse, Conflicts, Approve_Finally_As } = useScheduleManagement();
    const { Room_Get_Address } = useMapRenderer();
    const { Account_Fetch_ByID_Basic, Account_Fetch_ByID_FromState } = useAccounts();
    const [Account, Account_Set] = useState({ Name: "", Email: "" });
    const { Template_List } = useTemplating();
    const { Confirmer_Respond, Confirmer_Confirm } = useStatus();
    const Close = (Type) => {
        setTimeout(function () {
            UI.Subwindows_Close(id);
        }, 500);
    }


    useEffect(() => {
        Fetch(Schedule_Information.Requester.RequesterID)
    }, [Schedule_Information]);

    useEffect(() => {
        // document.getElementById("Reject_Reason").querySelector(".Dropdown_Button").click();
    }, []);

    const Fetch = async (ID) => {
        const Data = await Account_Fetch_ByID_Basic(ID);
        Account_Set(Data);
    }

    const Confirm = async () => {
        // console.log(Cleared);
        // Confirmer_Respond(true, { DelegatedStaff: Delegated_Staff, Equipment: Equipment, Request_Airconditioner: Allow_Aircon }, true, "Window_ScheduleManagement_Reserve_Approve_Delegate");
        Approve_Finally_As("GSU", {
            DelegatedStaff: Delegated_Staff,
            Equipment: Equipment,
            Request_Airconditioner: Allow_Aircon
        });
    }

    const Cancel = () => {
        // Confirmer_Respond(false, {}, true, "Window_ScheduleManagement_Reserve_Approve_Delegate");
        UI.Subwindows_Close("Window_ScheduleManagement_Reserve_Approve_Delegate");
    }

    const [Delegated_Staff, Delegated_Staff_Set] = useState([]);
    const [Equipment, Equipment_Set] = useState([]);
    const [Allow_Aircon, Allow_Aircon_Set] = useState(false);

    const Handle_Choose_Delegates = async () => {
        const { Response, Data } = await Confirmer_Confirm('Window_Accounts_Choose_Multiple');
        if (Response === "Confirmed") {
            Delegated_Staff_Set(Data);
        }
    }

    useEffect(() => {
        const Handle_Toggle = ({ ID, State }) => {
            if (ID.split("_")[1] === "Staff") {
                const index = parseInt(ID.replace("Item_Staff_", ""));
                const item = Template_List?.DelegatedStaff[index];

                Delegated_Staff_Set(prev => {
                    let updated = [...prev];

                    if (State === "Active") {
                        if (!updated.includes(item)) updated.push(item);
                    } else {
                        updated = updated.filter(eq => eq !== item);
                    }

                    return updated;
                });
            }
            if (ID.split("_")[1] === "Equipment") {
                const index = parseInt(ID.replace("Item_Equipment_", ""));
                const item = Schedule_Information?.Equipment[index];
                // console.log(item);
                Equipment_Set(prev => {
                    let updated = [...prev];
                    if (State === "Active") {
                        if (!updated.includes(item)) updated.push(item);
                    } else {
                        updated = updated.filter(eq => eq !== item);
                    }
                    return updated;
                });
            }
            if (ID.split("_")[1] === "Request" && ID.split("_")[2] === "Aircon") {
                if (State === "Active") {
                    Allow_Aircon_Set(true);
                } else {
                    Allow_Aircon_Set(false);
                }
            }

        };


        UI.on("Button_Toggled", Handle_Toggle);
        return () => {
            UI.off("Button_Toggled", Handle_Toggle);
        };
    }, [UI, Template_List, Schedule_Information]);

    useEffect(() => {
        if (Schedule_Information) {
            Delegated_Staff_Set(Schedule_Information.DelegatedStaff);
            Equipment_Set(Schedule_Information.Equipment);
        }

    }, []);

    return (
        <ui-subwindow Type='Subwindow' id={id} State='Active' Visibility='Open' {...(!isActive ? { inert: "" } : {})} style={{ height: "calc(100% - 10px)" }} Fullscreen={Schedule_Information?.Equipment.length > 0 || Schedule_Information?.Request_Airconditioner ? "Fullscreen" : ""}>
            <ui-subwindow-titlebar>
                <h2 className='Subwindow_TitleBar_Title'>

                </h2>
                <button className='Subwindow_TitleBar_Control' onClick={Cancel}             >
                    <img className='Subwindow_TitleBar_Control_Icon' src={Icon_Close} draggable='false' loading='lazy' alt='' />
                </button>
            </ui-subwindow-titlebar>
            <ui-subwindow-content>
                <div style={{ display: "grid", gridTemplateColumns: "auto 1fr", gap: "10px", alignItems: "center" }}>
                    <div className='Subwindow_Content_Icon'>
                        <img src={Icon_Success} className='Subwindow_Content_Icon_Image' draggable={false} loading='lazy' />
                    </div>
                    <div>
                        <h2 className='Subwindow_TitleBar_Title' style={{ textAlign: "left", marginBottom: "10px" }}>
                            Are you sure you want to approve this reservation request?
                        </h2>

                        <p className='General_Paragraph' style={{ textAlign: "left", marginBottom: "10px" }}>
                            You can delegate this schedule to staff listed below.
                        </p>
                    </div>
                </div>
                <div className='General_Split' Split={
                    Schedule_Information?.Equipment.length > 0 || Schedule_Information?.Request_Airconditioner ?
                        "3" : "2"
                }>
                    <div>
                        <UI_Card Type="Panel_Info" Text="Name" Figure={Schedule_Information?.Name} />
                        <UI_Card Type="Panel_Info" Text="Requested time" Figure={Time_Range_Parse(Schedule_Information?.Time.Start, Schedule_Information?.Time.End)} />
                        <UI_Card Type="Panel_Info" Text="Requested location" Figure={Room_Get_Address(Schedule_Information?.RoomID)} />
                        <UI_Card Type="Panel_Info" Text="Type of activity" Figure={Schedule_Information?.Activity.Type} />
                        <UI_Card Type="Panel_Info" Text="Requestant's name" Figure={Account.Name} />
                        <UI_Card Type="Panel_Info" Text="Requestant's email" Figure={Account.Email} />
                        <UI_Card Type="Panel_Info" Text="Number of attendees" Figure={Schedule_Information?.Activity.Attendees.Names.length} />
                        <div className='AM_Details_Data' id={id}>
                            <p className='General_Paragraph'>
                                Reservation status
                            </p>
                            <UI_ChipGroup Items={Status_Parse(Schedule_Information)} />
                        </div>
                    </div>
                    <div>
                        <UI_Divider Text="Delegate staff to this schedule (optional)" />
                        <div style={{marginBottom: "10px"}}>
                            <UI_Button
                                Text="Select staff to delegate"
                                OnClick={Handle_Choose_Delegates}
                            />
                        </div>
                        <UI_UpdatingStatus
                            State={Delegated_Staff.length > 0 ? "Good" : "Bad"}
                            Good={{
                                Type: "Custom",
                                Content: <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginBottom: "10px", marginTop: "10px" }}>
                                    {Delegated_Staff.map((Item, Index) => (
                                        // <UI_Toggle
                                        //     key={Index}
                                        //     id={`Item_Staff_${Index}`}
                                        //     Text={Item}
                                        //     Selected={Delegated_Staff?.includes(Item) ? "true" : "false"}
                                        // />
                                        <UI_Card
                                            Type="Schedule_List"
                                            Figure={{
                                                Title: Account_Fetch_ByID_FromState(Item).Name,
                                                Main: Account_Fetch_ByID_FromState(Item).Email
                                            }}
                                        // onClick={() => Reservation_Handle(Item._id)}
                                        />
                                    ))}
                                </div>
                            }}
                            Bad={{
                                Type: "Default",
                                Icon: "Default",
                                Title: "No accounts selected",
                                Text: "Select staff to delegate by clicking the button above."
                            }}
                        />
                    </div>
                    {Schedule_Information?.Equipment.length > 0 || Schedule_Information?.Request_Airconditioner ?
                        <div>
                            <UI_Divider Text="Approve any additional requests" />
                            <p className='General_Paragraph'>
                                Deselecting any buttons below will remove it to the reservation's approved equipment.
                            </p>
                            {Schedule_Information?.Request_Airconditioner ?
                                <>
                                    <UI_Divider Text="Requested use for room airconditioning" />
                                    <div style={{ display: "grid" }}>
                                        <UI_Toggle
                                            id={`Item_Request_Aircon`}
                                            Text="Allow use of room airconditioning"
                                        />
                                    </div>
                                </>
                                :
                                ""
                            }

                            {Schedule_Information?.Equipment.length > 0 ?
                                <>
                                    <UI_Divider Text="Requested equipment" />
                                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", alignItems: "center", gap: "10px", marginBottom: "10px", marginTop: "10px" }}>
                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                            {Schedule_Information?.Equipment.map((Item, Index) => (
                                                <UI_Toggle
                                                    key={Index}
                                                    id={`Item_Equipment_${Index}`}
                                                    Text={Item}
                                                    Selected="true"
                                                // Selected={Delegated_Staff?.includes(Item) ? "true" : "false"}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                </>
                                :
                                ""
                            }

                        </div>
                        :
                        ""
                    }


                </div>



            </ui-subwindow-content>
            <ui-subwindow-controls>
                <button className='General_Button Subwindow_Control' Type='Secondary' onClick={Cancel}>
                    Cancel
                </button>
                <button className='General_Button Subwindow_Control' Type='Secondary' State="Positive" onClick={Confirm}>
                    Approve as {Schedule_Action_Mode}
                </button>
            </ui-subwindow-controls>
        </ui-subwindow>
    );
}
